import { createSelector } from 'reselect';

const selectRoute = (state) => state.get('route');
const selectAuth = (state) => state.get('auth');

const makeSelectLocation = () => createSelector(
  selectRoute,
  (routeState) => routeState.get('location').toJS()
);

const makeSelectAuth = () => createSelector(
  selectAuth,
  (routeState) => routeState.toJS()
);

export {
  makeSelectAuth,
  makeSelectLocation,
};



// WEBPACK FOOTER //
// ./app/containers/App/selectors.js